import type { CampaignStatus } from "@adpilot/shared";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

const STATUS_VARIANTS = {
  enabled: "success",
  paused: "warning",
  archived: "neutral",
} as const satisfies Record<CampaignStatus, "success" | "warning" | "neutral">;

const STATUS_LABEL_KEYS = {
  enabled: "status.enabled",
  paused: "status.paused",
  archived: "status.archived",
} as const satisfies Record<CampaignStatus, string>;

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
}

export function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
  const { t } = useTranslation("campaign");

  return <Badge variant={STATUS_VARIANTS[status]}>{t(STATUS_LABEL_KEYS[status])}</Badge>;
}
